const currencySymbol = require('./currency-symbol');
const currencyPosition = require('./currency-position');
const thousandSeparator = require('../number/thousand-separator');

module.exports = function thousandSeparatorWithCurrency(value, currencyCode, delimiter, currencyDelimiter=``) {
  const symbol = currencySymbol(currencyCode);
  const position = currencyPosition(currencyCode);
  const formatted = thousandSeparator(value, delimiter);

  if (position === 'before') return `${symbol}${currencyDelimiter}${formatted}`;
  return `${formatted}${currencyDelimiter}${symbol}`;
};
